/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";

import { spacing } from "../../../../../../global/emotion";
import type { CardProps } from "../../../../refactor/Card/Card.emotion";
import { Card } from "../../../../refactor/Card/Card.emotion";
import { type TextProps } from "../../../_core/Text/Text.emotion";

const descriptionStyle: Interpolation = {
  textAlign: "center",
};
const infoContainerStyle: Interpolation = {
  height: "60px",
  paddingBottom: spacing.none,
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
};
const infoContainerNoDescriptionStyle: Interpolation = {
  display: "none",
};
const maskStyle: Interpolation = {
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
};
const maskContainerStyle: Interpolation = {
  marginBottom: -1,
};
const maskNoDescriptionStyle: Interpolation = {
  justifyContent: "flex-end",
  paddingBottom: spacing.m,
};
const titleStyle: Interpolation = {
  textAlign: "center",
};
const titleNoDescriptionStyle: Interpolation = {
  marginBottom: -32,
  textWrap: "wrap",
  whiteSpace: null,
};

export type CategoryMediumProps = CardProps & {
  noDescription?: boolean;
};

export const CategoryMedium = ({
  description,
  descriptionProps,
  imgContainerCSS = {},
  imgSrc,
  imgCSS = {},
  infoContainerCSS = {},
  maskProps,
  noDescription,
  title,
  titleProps,
  ...props
}: CategoryMediumProps) => (
  <Card
    description={description}
    imgSrc={imgSrc}
    title={title}
    {...props}
    descriptionCSS={descriptionStyle}
    descriptionProps={descriptionProps as TextProps}
    imgContainerCSS={imgContainerCSS}
    imgCSS={imgCSS}
    infoContainerCSS={[
      infoContainerStyle,
      noDescription && infoContainerNoDescriptionStyle,
      infoContainerCSS,
    ]}
    maskContainerCSS={maskContainerStyle}
    maskCSS={[maskStyle, noDescription && maskNoDescriptionStyle]}
    maskProps={maskProps}
    titleCSS={[titleStyle, noDescription && titleNoDescriptionStyle]}
    titleProps={titleProps}
  />
);
